export const goTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })